* {
  box-sizing: border-box;
}

.loading-container {
  display: flex;
  flex-direction: column;
  gap: calc(var(--spacer) * 5);
  width: 100%;
  .loading-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: calc(var(--spacer) * 9);
    width: 100%;
    max-width: calc(var(--spacer) * 10 + 10%);

    gz-loader {
      height: fit-content;
    }
  }

  .loading-section {
    margin-bottom: calc(var(--spacer) * 4);
  }
}

.header {
  padding: var(--spacer);
  height: calc(var(--spacer) * 9);
}

.widget-info-box {
  margin-bottom: calc(-2 * var(--spacer));
}

#patch-management {
  margin-top: calc(var(--spacer) * 3);
  .section {
    margin-bottom: calc(var(--spacer) * 4);
  }
}

.changed-info-box {
  position: relative;

  > * {
    position: absolute;
    background-color: var(--white-layout-302-level-1-elevation);
    padding-bottom: calc(var(--spacer) * 2) !important;
    z-index: 1;
  }
}
